/**
 * 侧边栏等展示用：账号权限状态
 * @returns {{ label: string, variant: 'super' | 'admin' | 'user' } | null}
 */
export function resolveUserRoleBadge(user) {
  if (!user) return null
  if (user.isSuper || user.role === 'SUPER') {
    return { label: '超级管理员', variant: 'super' }
  }
  if (user.canManageAccounts) {
    return { label: '管理员', variant: 'admin' }
  }
  return { label: '用户', variant: 'user' }
}
